module.exports = "<div class=\"program-list-container\">\r\n    <div class=\"program-container\" style=\"margin-left: -15px;\">\r\n        <app-property-types *ngFor=\"let propertyType of propertyTypes | orderByField:'name'\" [propertyType]=\"propertyType\"></app-property-types>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-type-list/property-type-list.component.html
// module id = ../../../../../src/app/collateralskillsets/property-type-list/property-type-list.component.html
// module chunks = main